export enum CustomPOIRequestStatus {
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  NOT_SUBMITTED = 'NOT_SUBMITTED',
}
